import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  modal: {
    width: "90vw",
  },
  quote: {
    width: "100%",
    padding: 0,
  },
  quoteContent: {
    padding: 0,
  },
  quoteList: {
    width: "100%",
  },
}));

export default styles;
